import notify from 'devextreme/ui/notify';
import store from '../store'

import {
    request
} from '../request/axios.request';

import {
    errorCommon
} from './error.common'

function getPublicBizContacts(openStatusId) {
    return request({
        baseURL: process.env.VUE_APP_BASE_API_URL_CONTACT,
        responseType: 'json',
        url: '/api/v2/BizContactApi/GetPublicBizContacts',
        params: {
            "OpenStatusId": openStatusId
        },
        method: 'get',
        handleRequest,
        handleResponse
    }).then(res => {
        console.log(res)
        if (res.status == 200) {
            return res.data;
        } else {
            notify("GetPublicBizContacts Failed !");
        }
    }).catch(err => {

        errorCommon.showError(err);

        return Promise.reject(err.message);
    });
}

function updateBizContactReadStatus(bizContactWorker) {
    return request({
        baseURL: process.env.VUE_APP_BASE_API_URL_CONTACT,
        responseType: 'json',
        url: '/api/v2/BizContactApi/UpdateBizContactReadStatus',
        method: 'post',
        data: {
            "BizContactWorker": bizContactWorker,
            "UpdateUserId": parseInt(store.state.constantAppUpdateUserId)
        },
        handleRequest,
        handleResponse
    }).then(res => {
        console.log(res)
        if (res.status == 200) {
            return res.data;
        } else {
            notify("UpdateBizContactReadStatus Failed !");
        }
    }).catch(err => {

        errorCommon.showError(err);

        return Promise.reject(err.message);
    });
}

function getBizContact(bizContactId) {
    return request({
        baseURL: process.env.VUE_APP_BASE_API_URL_CONTACT,
        responseType: 'json',
        url: '/api/v2/BizContactApi/GetBizContact?',
        method: 'get',
        params: {
            "BizContactId": bizContactId
        },
        handleRequest,
        handleResponse
    }).then(res => {
        console.log(res)
        if (res.status == 200) {
            return res.data;
        } else {
            notify("GetBizContact Failed !");
        }
    }).catch(err => {

        errorCommon.showError(err);

        return Promise.reject(err.message);
    });
}

function handleRequest(config) {

    //リクエスト送信する前に、実行したい処理をここに書く
    let url = config.url;

    if (url.indexOf("login") == -1) {

        config.headers.Authorization = 'Bearer ' + store.state.token;
    }

    return config;
}

function handleResponse() {
    //レスポンス受信したときに、実行したい処理をここに書く
}

export const contactService = {
    getPublicBizContacts,
    updateBizContactReadStatus,
    getBizContact,
};